import React from 'react';
import { Dropdown } from 'antd';
import { useSelfServiceLanguage } from '../context/SelfServiceLanguageContext';

const SelfServiceFooter = ({ quickProductsButtons }) => {
    const { t, language, setLanguage } = useSelfServiceLanguage();

    const languageMenu = {
        items: [
            {
                key: 'ru',
                label: t('russian'),
                onClick: () => setLanguage('ru'),
            },
            {
                key: 'kz',
                label: t('kazakh'),
                onClick: () => setLanguage('kz'),
            },
            {
                key: 'en',
                label: t('english'),
                onClick: () => setLanguage('en'),
            },
        ],
    };

    return (
        <div className="self-service-footer">
            {/* Top left corner */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="self-service-footer__corner self-service-footer__corner--left"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 32V0H32C24.5602 0 20.8403 0 17.7883 0.817781C9.50613 3.03699 3.03699 9.50614 0.81778 17.7883C0 20.8403 0 24.5602 0 32Z"
                    fill="#1E1E1E"
                />
            </svg>

            {/* Top right corner */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="self-service-footer__corner self-service-footer__corner--right"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 32V0H32C24.5602 0 20.8403 0 17.7883 0.817781C9.50613 3.03699 3.03699 9.50614 0.81778 17.7883C0 20.8403 0 24.5602 0 32Z"
                    fill="#1E1E1E"
                />
            </svg>

            {/* Quick products buttons - scrollable */}
            {quickProductsButtons && (
                <div style={{
                    flex: 1,
                    display: 'flex',
                    gap: '12px',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    paddingRight: '12px',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}>
                    <style>{`
                        .self-service-footer > div::-webkit-scrollbar {
                            display: none;
                        }
                    `}</style>
                    {quickProductsButtons}
                </div>
            )}

            {/* Right side - Language selector */}
            <Dropdown menu={languageMenu} trigger={['click']}>
                <div className="self-service-language">
                    <svg className="self-service-language__icon" viewBox="0 0 24 24" fill="none">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                        <path d="M2 12H22" stroke="currentColor" strokeWidth="2"/>
                        <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    {language === 'ru' ? t('russian') : language === 'kz' ? t('kazakh') : t('english')}
                </div>
            </Dropdown>
        </div>
    );
};

export default SelfServiceFooter;
